module.exports = __webpack_public_path__ + "img/avatar7.837d7633.png";